import RewardLottie from '@app/assets/lotties/Reward.json';
import LottieView from 'lottie-react-native';
import { useEffect, useRef } from 'react';
import { Platform } from 'react-native';

const IDLE_START = 0;
const IDLE_END = 49;
const IDLE_DELAY = 800;

export function RewardTabLottie({ focused }: { focused: boolean }) {
  const ref = useRef<LottieView>(null);
  const timeoutRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  const playIdle = () => {
    const v = ref.current;
    if (!v) return;

    if (Platform.OS === 'web') {
      v.play(IDLE_START, IDLE_END);
      v.play();
    } else {
      v.play(IDLE_START, IDLE_END);
    }
  };

  const playFull = () => {
    const v = ref.current;
    if (!v) return;

      v.reset();
      v.play(50,200);
  };


  useEffect(() => {
    focused ? playFull() : playIdle();
  }, [focused]);

  useEffect(() => {
    return () => {
      if (timeoutRef.current != null) {
        clearTimeout(timeoutRef.current);
        timeoutRef.current = null;
      }
      ref.current = null;
    };
  }, []);

  const onAnimationFinish = () => {
    if (focused) return;

    timeoutRef.current = setTimeout(playIdle, IDLE_DELAY);
  };

  return (
    <LottieView
      key={`reward-${focused}`}
      ref={ref}
      source={RewardLottie as any}
      autoPlay={false}
      loop={false}
      style={{ width: 80, height: 72 }}
      onAnimationFinish={onAnimationFinish}
    />
  );
}
